/**
 * `undefined` while in flight, so the caller draws a skeleton. The pluralising is the caller's
 * `t`: i18next picks the form from `count`, which holds for a language with six forms too.
 */
export function countLabel(value: number | undefined, label: (count: number) => string) {
  return value === undefined ? undefined : label(value);
}
